import axios from "axios";
import React, { useState } from "react";
import { SERVER_PATH } from "../../config/env";
import { successToaster } from "../../utils/index";
import { userInfo } from "../../utils/appInfo";

export const AddressForm = (props) => {
  const { hide, addressData } = props;
  let { imageUrl = "", email = "" } = userInfo();

  let adddressInfo = {
    mobile_no: "",
    address: "",
    pincode: "",
    user_id: email,
    user_name: "",
    avatar: imageUrl,
    status: "1",
    state: "",
  };

  const url = `${SERVER_PATH}put/user.php`;
  const [data, setData] = useState(adddressInfo);

  const dataHandler = (e) => {
    const arr = { ...data };
    arr[e.target.name] = e.target.value;
    setData(arr);
  };

  const numberHandler = (e, field, maxLen) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > maxLen) value = value.slice(0, maxLen);
    setData({ ...data, [field]: value });
  };

  const addressSubmit = async (e) => {
    e.preventDefault();

    // ❌ no alert → rely on HTML validation
    let info = { ...data };

    await axios
      .post(url, {
        ...info,
        user_id: email,
      })
      .then((res) => {
        setData(adddressInfo);
        addressData();
        successToaster({ msg: "Address added successfully" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form onSubmit={addressSubmit}>
        <div className="row g-3 my-1">

          <div className="col-md-4">
            <label htmlFor="validationCustom02" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              required
              name="user_name"
              placeholder="Enter fullname"
              value={data.user_name}
              onChange={(e) => dataHandler(e)}
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom02" className="form-label">
              Mobile Number
            </label>
            <input
              type="text"
              className="form-control"
              required
              name="mobile_no"
              placeholder="Enter 10 digit number"
              value={data.mobile_no}
              onChange={(e) => numberHandler(e, "mobile_no", 10)}
              maxLength="10"
              pattern="\d{10}"
              inputMode="numeric"
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="inputState" className="form-label">
              State
            </label>
            <select
              id="inputState"
              className="form-select"
              name="state"
              value={data.state}
              required
              onChange={(e) => dataHandler(e)}
            >
              <option value="">Choose State...</option>
              <option value="andhra pradesh">Andhra Pradesh</option>
              <option value="arunachal pradesh">Arunachal Pradesh</option>
              <option value="assam">Assam</option>
              <option value="bihar">Bihar</option>
              <option value="chhattisgarh">Chhattisgarh</option>
              <option value="goa">Goa</option>
              <option value="gujarat">Gujarat</option>
              <option value="haryana">Haryana</option>
              <option value="himachal pradesh">Himachal Pradesh</option>
              <option value="jharkhand">Jharkhand</option>
              <option value="karnataka">Karnataka</option>
              <option value="kerala">Kerala</option>
              <option value="madhya pradesh">Madhya Pradesh</option>
              <option value="maharashtra">Maharashtra</option>
              <option value="tamilnadu">Tamil Nadu</option>
              <option value="telangana">Telangana</option>
              <option value="uttar pradesh">Uttar Pradesh</option>
              <option value="west bengal">West Bengal</option>
            </select>
          </div>

          <div className="col-md-12">
            <label htmlFor="validationCustom03" className="form-label">
              Address
            </label>
            <textarea
              className="form-control"
              required
              name="address"
              value={data.address}
              placeholder="Enter your address"
              onChange={(e) => dataHandler(e)}
            ></textarea>
          </div>

          <div className="col-md-4 mb-3">
            <label htmlFor="validationCustom02" className="form-label">
              Pincode
            </label>
            <input
              type="text"
              className="form-control"
              required
              name="pincode"
              placeholder="Enter Pincode"
              value={data.pincode}
              onChange={(e) => numberHandler(e, "pincode", 6)}
              maxLength="6"
              pattern="\d{6}"
              inputMode="numeric"
            />
          </div>

          <div className="col-12">
            <input type="submit" className="btn btn-primary" value="Submit" />
            &nbsp;
            <input
              type="button"
              className="btn btn-warning"
              value="Cancel"
              onClick={hide}
            />
          </div>

        </div>
      </form>
    </>
  );
};